import { render, staticRenderFns } from "./WeixinApiSetting.vue?vue&type=template&id=05277a18&scoped=true&"
import script from "./WeixinApiSetting.vue?vue&type=script&lang=ts&"
export * from "./WeixinApiSetting.vue?vue&type=script&lang=ts&"
import style0 from "./WeixinApiSetting.vue?vue&type=style&index=0&id=05277a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05277a18",
  null
  
)

export default component.exports